import { countryISOMap } from './utils';

export enum RoamingTab {
  TravellingAbroad,
  CallToAbroad,
}

export type CountryData = {
  countryCode: keyof typeof countryISOMap;
  countryPrefix: string;
  countryNameIS: string;
  travelPackage: boolean;
  minToIceland: number;
  minAccepted: number;
  SMS: number;
  mobileInternet: number;
  roamingEurope: boolean;
  '5G': boolean;
  startForeignGSM: number;
  minForeignGSM: number;
  smsForeignGSM: number;
  startForeignHomePhone: number;
  minForeignHomePhone: number;
  roamingEuropeExtraMB: number;
  roamingCatagory: number;
};
